export interface ExportColumn {
  key: string;
  label: string;
  format?: (value: any, row: any) => string;
  /** PDF: fester Breitenanteil der Spalte (nur wirksam, wenn alle Spalten einen haben) */
  breite?: number;
}

export interface ExportStats {
  items: { label: string; value: string | number }[];
}

export interface ExportConfig {
  title: string;
  columns: ExportColumn[];
  data: any[];
  fileName?: string;
  stats?: ExportStats;
  /** PDF: Schriftgröße der Tabelle in pt (Standard 6). Zeilenhöhe wächst mit. */
  schrift?: number;
  /** PDF: zu langen Text in weitere Zeilen umbrechen statt mit "..." abschneiden */
  umbruch?: boolean;
}

export const getCellValue = (row: any, col: ExportColumn): string => {
  const raw = row[col.key];
  if (col.format) return col.format(raw, row);
  if (raw == null) return '';
  return String(raw);
};

export const generateFileName = (title: string, suffix?: string): string => {
  const datum = new Date().toLocaleDateString('de-DE').replace(/\./g, '-');
  return suffix ? `${title}_${datum}_${suffix}` : `${title}_${datum}`;
};

export const downloadBlob = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
